import Header from '../components/Header';
import Footer from '../components/Footer';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import AdSlot from '../components/AdSlot';
import Link from '../components/Link';
import { useLicenseContext } from '../lib/LicenseContext';
import heroImage from '../assets/hero-qr-codes.png';
import { ADS_ENABLED } from '../lib/ads'; // disabled for AdSense review readiness

export default function Landing() {
  const { isPro, startCheckout } = useLicenseContext();

  return (
    <div className="layout-container landing-page">
      <div className="container">
        <Header />

        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">Generate Beautiful QR Codes at Scale</h1>
            <p className="hero-description">
              The fastest way to create, customize, and export hundreds of QR codes in seconds.
              Perfect for marketing campaigns, product labeling, and event management.
            </p>
            <div className="hero-cta">
              {isPro ? (
                <Link to="/app" className="btn btn-primary btn-lg">
                  Open PrintQR App
                </Link>
              ) : (
                <>
                  <button
                    onClick={startCheckout}
                    className="btn btn-primary btn-lg"
                  >
                    Unlock Lifetime Pro
                  </button>
                  <Link to="/app" className="btn btn-outline btn-lg">
                    Try Free
                  </Link>
                </>
              )}
            </div>
          </div>

          <div className="hero-image">
            <img
              src={heroImage}
              alt="PrintQR - Bulk QR Code Generator with CSV import"
              width={600}
              height={400}
              onError={(e) => {
                // Fallback if something goes wrong loading the hero asset
                e.currentTarget.src =
                  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="600" height="400" viewBox="0 0 600 400" fill="none"%3E%3Crect width="600" height="400" fill="%23f5f5f5"/%3E%3Ctext x="300" y="200" font-family="sans-serif" font-size="24" text-anchor="middle" fill="%23333333"%3EPrintQR Preview%3C/text%3E%3C/svg%3E';
              }}
            />
          </div>
        </section>

        {/* Ad slot: disabled for AdSense review readiness */}
        {ADS_ENABLED && import.meta.env.PROD && (
          <AdSlot slotId="landing-top" mode="network" size="banner" className="mt-8" />
        )}

        {/* Features Section */}
        <Features />

        {/* Pricing Section */}
        <Pricing />

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h2 className="cta-title">Ready to create professional QR codes?</h2>
            <p className="cta-description">
              Start generating high-quality QR codes today - no registration required.
            </p>
            {isPro ? (
              <Link to="/app" className="btn btn-primary btn-lg">
                Open PrintQR Now
              </Link>
            ) : (
              <button
                onClick={startCheckout}
                className="btn btn-primary btn-lg"
              >
                Unlock Lifetime Pro
              </button>
            )}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
